import { Component, Inject, inject } from '@angular/core';
import { CoreLibModalComponent } from '../modal/modal.component';
import { DialogRef } from '../modal/dialog-ref';
import { DIALOG_DATA } from '../modal/dialog-tokens';
import { ConciergeConfigService } from 'app/concierge/concierge-config/services/concierge-config.service';
import { ErrorHandlerService, ErrorCodeMap } from 'src/app/core-lib/services/error-handler/error-handler.service';
import { UtilService } from 'app/shared/util.service';

const DEMO_ERROR_CODES: ErrorCodeMap = {
  14050: 'errors.concierge.test.TEMPLATE_NOT_FOUND',
  14051: 'errors.concierge.test.TEMPLATE_LANGUAGE_NOT_FOUND',
  14052: 'errors.concierge.test.MESSAGE_FAILED',
  14053: 'errors.concierge.test.INVALID_PHONE_NUMBER',
  14054: 'errors.concierge.test.PHONE_FORMAT_ERROR',
  14055: 'errors.concierge.test.SLACK_NOTIFICATION_FAILED',
};

@Component({
    selector: 'mh-concierge-test-modal',
    templateUrl: './concierge-test-modal.component.html',
    styleUrls: ['./concierge-test-modal.component.scss'],
    standalone: false
})
export class ConciergeTestModalComponent extends CoreLibModalComponent {
  phoneNumber: string = '';
  isSuccess: boolean = false;
  errorMessage: string = '';
  isLoading: boolean = false;
  utilService = inject(UtilService);

  constructor(
    protected dialogRef: DialogRef, 
    @Inject(DIALOG_DATA) public data,
    private conciergeConfigService: ConciergeConfigService,
    private errorHandler: ErrorHandlerService
  ) {
    super(dialogRef, data);
  }

  onSavePhoneNumber() {
    if (this.isValidPhone() && !this.isLoading) {
      this.errorMessage = '';
      this.isLoading = true;
      this.utilService.ga('', 'lead_form_submission', null, null, { step: 'phone_saved', product: 'concierge' });
      
      this.conciergeConfigService.testConciergeDemo(this.data.customerId, this.phoneNumber).subscribe({
        next: () => {
          this.isSuccess = true;
          this.isLoading = false;
        },
        error: (err) => {
          const result = this.errorHandler.getErrorMessage(err, DEMO_ERROR_CODES);
          this.errorMessage = result.message || 'concierge.main.line_not_available';
          this.isLoading = false;
        }
      });
    }
  }

  isValidPhone(): boolean {
    return this.phoneNumber.length >= 8;
  }
}
